<script setup lang="ts">
import { onMounted, ref } from 'vue';

const isVisible = ref<boolean>(false);

onMounted(() => {
  isVisible.value = true;
});
</script>

<template>
  <Transition name="fade-transition">
    <slot v-if="isVisible" />
  </Transition>
</template>

<style scoped lang="scss">
@import '../../../styles/_media.scss';
@include for-less-or-equal-than-1200-px {
  .fade-transition-enter-active,
  .fade-transition-leave-active {
    transition: opacity var(--transition-long);
  }
  .fade-transition-enter-from,
  .fade-transition-leave-to {
    opacity: 0;
  }
}
.fade-transition-enter-active,
.fade-transition-leave-active {
  transition: opacity var(--transition-time-medium) ease-out
    var(--transition-time-medium);
}
.fade-transition-enter-from,
.fade-transition-leave-to {
  opacity: 0;
}
</style>
